/**
 * @generated SignedSource<<5eeb0c37acf140b8b7d6125c5d15a5af>>
 * @relayHash 049c82e29ed1a2b0e74fdaf87f3cd207
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8cea54b03b9bf2b6ab70d6fb95eaaf592bcb8a8e1ea67d60358e29249f6dfedb

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { hubHomeContentWrapperQuery } from './hubHomeContentWrapperQuery.graphql';

const node: PreloadableConcreteRequest<hubHomeContentWrapperQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8cea54b03b9bf2b6ab70d6fb95eaaf592bcb8a8e1ea67d60358e29249f6dfedb",
    "metadata": {},
    "name": "hubHomeContentWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
